<template>
  <div class="gameAreaRapper">
    <header>
      <div>
        <img src="~assets/images/game/return.png" alt @click="returnpage" />
      </div>
      <span>专区</span>
      <div></div>
    </header>
    <div class="content">
      <div class="gameBox" v-for="game in areaList" :key="game.id" @click="enterDetails(game)">
        <img v-lazy="game.topicBanner" :key="game.topicBanner" alt />
        <p>{{game.topicName}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { goBack, androidMethod } from "@/utils/base";
import config from '@/../config'
export default {
  data() {
    return {
      areaList: [],
      location: '',
      addNewMemberIntoGroupcount:0
    };
  },
  created() {
    const { location } = this.$route.query;
    this.location = location || '';
    androidMethod('setStatusColor','','1','#fff');
    androidMethod('setStatusMode', '', "true");
    this.$http
      .get("/apiserv/GameX/Frontend/specialTopic/getSpecialTopicsByPower")
      .then(res => {
        if (res.data.return_code == 200) {
          const recData = res.data.data;
          if (recData) {
            recData.forEach((i, index) => {
              i.index = index + 1;
            })
          }
          this.areaList = res.data.data;
        }
      });
  },
  methods: {
    returnpage() {
      if (this.location === 'website') {
        window.history.back();
        return;
      }
      goBack();
    },
    enterDetails(game) {
      // if(AllData.abtestdata && AllData.abtestdata['skeleton'] && AllData.abtestdata['skeleton'].val == 'true'){
      //   var baseParams = JSON.parse(androidMethod('getBaseParams') || '{}');
      //   var str = `flight_type=web&vid=${AllData.abtestdata['skeleton'].vid}`;
      //   for(var key in baseParams){
      //     if(typeof baseParams[key] !== 'object'){
      //       str = str + '&' + key + "=" + baseParams[key]
      //     }
      //   }
      //   this.$http.get(`${config.ABTEST_URL}/v1/addNewMemberIntoGroup?${str}`).then((res) => {
      //     if(res.data.code == 200){
      //       if (location.href.indexOf('?') > -1) {
      //         var p = location.href.split('?');
      //         location.href = `${config.LEYUAN_URL}/areadetail.a.html#/game/areadetails?id=${game.id}&index=${game.index}&abtest=1&${p[1]}`;
      //         // location.href = `http://172.16.22.64:8081/#/game/areadetails?id=${game.id}&index=${game.index}&${p[1]}`;
      //       } else {
      //         location.href = `${config.LEYUAN_URL}/areadetail.a.html#/game/areadetails?id=${game.id}&index=${game.index}&abtest=1`;
      //         // location.href = `http://172.16.22.66:8080/#/game/areadetails?id=${game.id}&index=${game.index}&abtest=1`;
      //       }
      //     }
      //   })
      // }else{
        this.$router.push({ path: "/game/areadetails", query: { id: game.id, index: game.index, ...this.$route.query } });
      // }
    },
  }
};
</script>

<style lang='less' scoped>
.gameAreaRapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  header {
    height: 0.5rem;
    display: flex;
    padding: 0.166rem;
    > :nth-child(1) {
      flex: 1;
      display: flex;
      align-items: center;
      img {
        width: 0.25rem;
        height: 0.25rem;
        margin-left: -0.05rem;
      }
    }
    > :nth-child(2) {
      flex: 3;
      text-align: center;
      line-height: 0.168rem;
      font-size: 0.19rem;
      font-weight: 400;
      color: rgba(27, 27, 27, 1);
    }
    > :nth-child(3) {
      flex: 1;
    }
  }
  .content {
    flex: 1;
    height: 6.17rem;
    padding: 0.17rem;
    background: #e6e6e6;
    overflow: scroll;
    .gameBox {
      width: 1.65rem;
      text-align: center;
      float: left;
      margin-right: 0.1rem;
      background: #fff;
      border-radius: 0.08rem;
      margin-bottom: 0.12rem;
      img {
        width: 1.65rem;
        height: 0.82rem;
        border-top-left-radius: 0.08rem;
        border-top-right-radius: 0.08rem;
      }
      p {
        color: #1c1c1c;
        font-size: 0.14rem;
      }
    }
    > :nth-child(even) {
      margin-right: 0;
    }
  }
}
</style>  